export default __webpack_public_path__ + "5c9ad960c00657054415bbf6490203d2.png";